<template>
  <div>
    <div v-if="show" class="overlay" @click="closeModal" />
    <transition
      :name="
        fullHeight
          ? 'full-bottom-sheet-transition'
          : fitHeight
            ? 'fit-bottom-sheet-transition'
            : 'bottom-sheet-transition'
      "
    >
      <div
        v-if="show"
        class="bottom-sheet"
        :class="[
          backgroundColor,
          fullHeight
            ? 'h-full'
            : fitHeight
              ? 'rounded-t-[15px] h-fit'
              : 'rounded-t-[15px] h-[80vh]',
        ]"
      >
        <div :class="fitHeight ? 'pt-5' : 'py-5'">
          <div>
            <div
              v-if="fullHeight"
              class="flex justify-end px-5"
              :class="{ 'mb-5': $slots.header }"
            >
              <IconClose
                class="text-gray-1 text-[14px] cursor-pointer"
                @click="closeModal"
              />
            </div>
            <div v-if="$slots.header" class="px-5 border-b border-gray-2">
              <slot name="header" />
            </div>
          </div>
          <div class="h-full">
            <slot />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  fullHeight: { type: Boolean, default: false },
  fitHeight: { type: Boolean, default: false },
  backgroundColor: { type: String, default: "bg-body-bg" },
});

const emit = defineEmits(["update:show"]);

function closeModal() {
  emit("update:show", false);
}
</script>
